<div class="summary-container">
    <input type="hidden" id="pages" [value]="pageCount">


    <!-- Informacoes do usuario -->
    <div class="summary-heading-top-container pages page-1" style="width: 100%;">
        <div style="display: flex;flex-direction: column;gap: 15px;">
            <div style="display: flex;align-items: center;gap: 5px;">
                <div class="profile-details-big">
                    <img *ngIf="participant?.user?.imageUrl"
                         [src]="getImageUrl(participant?.user?.imageUrl)"
                         alt=""/>
                    <img *ngIf="!participant?.user?.imageUrl"
                         src="/assets/imgs/user-image-placeholder.png"
                         alt=""/>
                </div>

                <div>
                    <h3>{{ participant?.user?.name }}</h3>
                    <p>{{ participant?.user?.rank || '--' }}</p>
                </div>
            </div>
            <div style="display: flex;align-items: flex-end;gap: 5px;">
                <div class="profile-details">
                    <p>{{ 'dashboard.lineManager' | translate }}</p>
                    <img *ngIf="participant?.user?.lineManagerImage"
                         [src]="getImageUrl(participant?.user?.lineManagerImage)"
                         alt=""/>
                    <img *ngIf="!participant?.user?.lineManagerImage"
                         src="/assets/imgs/user-image-placeholder.png"
                         alt=""/>
                </div>
                <div style="height: 70px;">
                    <p><b>{{ participant?.user?.lineManager || '--' }}</b></p>
                    <p>{{ '--' }}</p>
                </div>
            </div>
        </div>
        <div style="border-left: 1px solid #b9b9b9 ;height: 200px;">

        </div>

        <div style="display: flex;flex-direction: column;">
            <div>
                <p>{{ 'generic.group' | translate }}</p>
                <p><b>{{ participant?.user?.group || '--' }}</b></p>
            </div>
            <div>
                <p>{{ 'cycleParticipants.businessUnit' | translate }}</p>
                <p><b>{{ participant?.user?.unit || '--' }}</b></p>
            </div>
            <div>
                <p>{{ 'cycleParticipants.segment' | translate }}</p>
                <p><b>{{ participant?.user?.segment || '--' }}</b></p>
            </div>
        </div>
        <div style="display: flex;flex-direction: column;">
            <div>
                <p>{{ 'cycleParticipants.location' | translate }}</p>
                <p><b>{{ participant?.user?.location || '--' }}</b></p>
            </div>
            <div>
                <p>{{ 'generic.serviceDate' | translate }}</p>
                <p><b>{{ participant?.user?.serviceDate | date : 'dd/MM/yyyy' }}</b></p>
            </div>
            <div>
                <p>{{ 'generic.hireDate' | translate }}</p>
                <p><b>{{ participant?.user?.hireDate | date : 'dd/MM/yyyy' }}</b></p>
            </div>
        </div>

    </div>

    <!-- avaliacao geral -->
    <div class="summary-heading pages page-1">
        <h1>{{ 'calibration.overallEvaluation' | translate }}</h1>
    </div>

    <div class="pages page-1"
         [ngClass]="isExportMode ? 'valuation-tables-container-export' : 'valuation-tables-container'">
        <div [ngStyle]="{'width': isExportMode? '100%' : '60%'}">
            <app-general-valuation-table [user]="participant"></app-general-valuation-table>
        </div>
        <div [ngStyle]="{'width': isExportMode? '100%' : '40%'}">
            <app-general-valuation-final-concepts-table
                    [user]="participant"></app-general-valuation-final-concepts-table>
        </div>
    </div>

    <!-- resumo das avaliacoes 360 -->
    <div class="summary-heading pages page-2">
        <h1>{{ 'aiSummary.360evaluations.Title' | translate }}</h1>
    </div>
    <div class="text-generated-container pages page-2">
        <div class="card-by-ai">
            <ion-icon slot="icon-only" src="/assets/imgs/star-shine.svg"></ion-icon>
            {{ 'aiSummary.SymmaryByAi' | translate }}
        </div>
        <p>
            {{ threeSixtySummaryText || ('aiSummary.NoTextFound' | translate) }}
        </p>
    </div>

    <!-- Resumo avaliacoes livres -->
    <div class="summary-heading pages page-2">
        <h1>{{ 'aiSummary.FreeEvaluations.Title' | translate }}</h1>
    </div>
    <div class="text-generated-container pages page-2">
        <div class="card-by-ai">
            <ion-icon slot="icon-only" src="/assets/imgs/star-shine.svg"></ion-icon>
            {{ 'aiSummary.SymmaryByAi' | translate }}
        </div>
        <p>
            {{ freeSummaryText || ('aiSummary.NoTextFound' | translate) }}
        </p>
    </div>

    <!-- Tags das avaliacoes 360 e Livres -->
    <div class="summary-heading pages page-2">
        <h1>{{ 'aiSummary.SelectTag.Threesixty.Title' | translate }}</h1>
    </div>
    <ai-tags-summary-chart
            [aiBulletPointsData]="aiThreeSixtyAndFreeBulletPointsData"
            [isExportMode]="isExportMode"
            [startPage]="2"
    ></ai-tags-summary-chart>


</div>
<div *ngIf="threeSixtyLeadershipText" class="summary-container">
    <!-- Gestao lideranca -->
    <div class="summary-heading pages page-3">
        <h1>{{ 'aiSummary.ManagementLeadership.Title' | translate }}</h1>
    </div>
    <div class=" pages page-3" style="flex-direction: column;">
        <app-management-leadership-table [user]="participant"></app-management-leadership-table>
    </div>

    <!-- Resumo das Avaliacoes 360 Leadership -->
    <div class="summary-heading pages page-3">
        <h1>{{ 'aiSummary.360Leadership.Title' | translate }}</h1>
    </div>
    <div class="text-generated-container pages page-3">
        <div class="card-by-ai">
            <ion-icon slot="icon-only" src="/assets/imgs/star-shine.svg"></ion-icon>
            {{ 'aiSummary.SymmaryByAi' | translate }}
        </div>
        <p>
            {{ threeSixtyLeadershipText || ('aiSummary.NoTextFound' | translate) }}
        </p>
    </div>

    <!-- Tags das avaliações 360 Leadership -->
    <div class="summary-heading pages page-4">
        <h1>{{ 'aiSummary.SelectTag.ThreesixtyLeadership.Title' | translate }}</h1>
    </div>
    <ai-tags-summary-chart [aiBulletPointsData]="aiThreeSixtyLeadershipBulletPointsData"
                           [ngStyle]="{'padding-bottom': isExportMode? '0px' : '50px'}"
                           [isExportMode]="isExportMode"
                           [startPage]="4"
    ></ai-tags-summary-chart>
</div>